import React from "react";
import classNames from "classnames";
import { ChildrenProps } from "../../types";
import styles from "./CollapsibleInfoBanner.module.scss";

interface Props extends ChildrenProps {
    className?: string;
}

/** @deprecated Use @design-system/Accordion/Accordion. CollapsibleInfoBanner is deprecated. */
export const CollapsibleInfoBanner: React.FC<Props> = ({
    className,
    children,
}) => (
    <section className={classNames(styles.banner, className)}>
        {children}
    </section>
);
